"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DATE_FORMATS = "DateTimeConfigCache.DATE_FORMATS";
class DateTimeConfig {
    constructor(cache, defaults) {
        this.handlers = [];
        this.isUpdateObsolete = false;
        this.setFormat = async (dateTimeFormat, dateFormat, timeFormat) => {
            await this.cache
                .setObject(DATE_FORMATS, {
                dateTime: dateTimeFormat,
                date: dateFormat,
                time: timeFormat,
            })
                .asPromise();
            this.isUpdateObsolete = true;
            for (const handler of this.handlers) {
                handler.setFormats(dateTimeFormat, dateFormat, timeFormat);
            }
        };
        this.getFormats = async () => (await this.cache
            .getObject(DATE_FORMATS)
            .withDefault({
            dateTime: this.defaults.dateTime,
            date: this.defaults.date,
            time: this.defaults.time,
        })
            .asPromise());
        this.cache = cache;
        if (defaults) {
            this.defaults = defaults;
        }
    }
    onChange(handler) {
        this.handlers.push(handler);
        handler.setFormats(this.defaults.dateTime, this.defaults.date, this.defaults.time);
        this.getFormats().then((formats) => {
            if (!this.isUpdateObsolete) {
                handler.setFormats(formats.dateTime, formats.date, formats.time);
            }
        });
    }
}
exports.default = DateTimeConfig;
//# sourceMappingURL=DateTimeConfig.js.map